import * as z from "zod";

/**
 * Newline/line break node.
 */
const NewlineNodeSchema_ = z.object({ type: z.literal("newline") });

/** Base type from schema inference (no index signature) */
type NewlineNodeBase = z.infer<typeof NewlineNodeSchema_>;

/** Full type with index signature for FlowContentNode compatibility */
export type NewlineNode = NewlineNodeBase & { [key: string]: unknown };

export const NewlineNodeSchema: z.ZodType<NewlineNode> = NewlineNodeSchema_;
